export const EquationCardFlag = () =>{
    return(
        <div className="container">
            <p>数式エディタの場所のフラグの条件を示します。</p>
            <img src={`${process.env.PUBLIC_URL}/equation_card_flag.png`}></img>
            <p>図の例でフラグが１のものを指定しています</p>
            </div>
    )
}
